import { FC } from 'react';
import { Grid2 as Grid, IconButton, Typography } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { getAnchorRowStyle } from 'framework/ui/field';
import { defaultsDeep } from 'lodash';
import { PlusIcon } from 'framework/ui/mui-builder';
import { EditableListDataGridLayout, EDITABLE_LIST_FIELD, EditableListFormShowTemplate } from 'framework/list';
import { EditActionField } from './fields';
import { ShowSection } from 'framework/ui/layout';
import {
  ACCESS_INFO_ACTIONS,
  ACCESS_INFO_SECTIONS,
  useProjectSecurityContext,
  useProjectDataContext,
  ProjectSectionAccordion,
} from 'domain/shared/newProject';
import { getBugTableCells } from './getBugTableCells';
import { useBugCrud } from '../CreateAndUpdateBug/BugCrudProvider';

const UserReportedBugs: FC = () => {
  const { data: projectData } = useProjectDataContext();
  const { isAccessGranted } = useProjectSecurityContext();
  const canManage = isAccessGranted(ACCESS_INFO_SECTIONS.ENGINEERING, ACCESS_INFO_ACTIONS.MANAGE);
  const { hash } = useLocation();
  const { openCreate, openUpdate } = useBugCrud();

  return (
    <ShowSection sx={{ '&.section-details__wrapper': { p: '0px !important' } }}>
      <EditableListFormShowTemplate
        listSource="engineeringBugs"
        localStorageKey={projectData?.id ? `project:${projectData.id}:engineeringBugs` : undefined}
      >
        <ProjectSectionAccordion
          defaultExpanded
          title={
            <Grid
              container
              direction="row"
              sx={{
                justifyContent: 'space-between',
                alignItems: 'center',
                width: '100%',
                pl: 2,
                gap: { xs: 4, md: 16 },
              }}
            >
              <Grid size={8}>
                <Typography variant="h4" color="primary" noWrap>
                  User-reported bugs
                </Typography>
              </Grid>
              <Grid size="auto" display="flex" alignItems="center" mr={0.7}>
                {canManage && (
                  <IconButton sx={{ p: 0, ml: 1 }} onClick={openCreate}>
                    <PlusIcon />
                  </IconButton>
                )}
              </Grid>
            </Grid>
          }
        >
          <EditableListDataGridLayout
            rowProps={data =>
              defaultsDeep(getAnchorRowStyle(data, hash), {
                sx: { alignItems: 'center', py: 2 },
              })
            }
            getRowEnabled={() => true}
            getTableCells={async () => [
              ...getBugTableCells({}),
              ...(canManage
                ? [
                    {
                      type: EDITABLE_LIST_FIELD,
                      source: 'id',
                      isEditor: false,
                      component: EditActionField,
                      componentProps: { onEdit: openUpdate },
                      gridCellProps: { size: 0.5 },
                    },
                  ]
                : []),
            ]}
          />
        </ProjectSectionAccordion>
      </EditableListFormShowTemplate>
    </ShowSection>
  );
};

export default UserReportedBugs;
